// El tenant DUENO de la plataforma (Lucky Soft). El resto de los tenants son
// clientes: cada uno es `master` de SU tenant, por eso el rol no alcanza para
// distinguirlos. Debe coincidir con OWNER_TENANT_SLUG del backend (.env.combatwin).
export const OWNER_TENANT_SLUG = "combatwin";
